import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';

// Example CSS (Optional): You can create your own About.css and import it here
// import './About.css';

const About = ({ showBreadcrumbs = true }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize AOS library
    AOS.init({
      duration: 800, // Animation duration in ms
      offset: 100,   // Offset (in px) from the original trigger point
      once: true,    // Whether animation should happen only once - while scrolling down
    });
  }, []);

  return (
    <>
      {/* Conditionally render Breadcrumbs */}
      {showBreadcrumbs && (
        <Breadcrumbs
          pageTitle="About Us"
          activePage="About Us"
        />
      )}

      {/* ===================== INTRO SECTION ===================== */}
      <section id="about-us" className="about-info">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* TEXT */}
            <div className="col-lg-6" data-aos="fade-left">
              <small className="mb-2 text-danger">Innovative Solutions, Scalable Growth.</small>
              <h2 className="mb-2">Our Web & Software Development Services</h2>
              <p>
                 Welcome to our innovative Spadez solutions company, where technology meets efficiency. Based in Mohali, India, we specialize in 
                 delivering cutting-edge software and web development services tailored to meet diverse business needs. Our team of skilled professionals is 
                 dedicated to crafting scalable, user-friendly, and high-performing solutions that work seamlessly across platforms.
              </p>
              <p>
                We cater to businesses of all sizes, from emerging startups to established enterprises, ensuring that every project benefits from our expertise, innovation,
                and commitment to quality. Our goal is to simplify complex challenges and provide solutions that drive success.
              </p>
              <p>
                <small>
                At the heart of our company lies a commitment to delivering exceptional digital solutions
                 to clients worldwide. Whether you're a fast-growing startup or an industry leader, our team is dedicated to understanding your unique challenges and providing tailored, high quality services.
                </small>
              </p>
              <ul className="list-unstyled services-list">
                <li>Custom Software Development</li>
                <li>Mobile App Development</li>
                <li>Legacy System Upgrades</li>
                <li>Data & Business Intelligence</li>
                <li>UI/UX Solutions</li>
                <li>Data & Analytics</li>
                <li>No Code & Low Code Platforms </li>
                <li>Dedicated Development Team</li>
                <li>WordPress Customization</li>
                <li>WordPress Website Design</li>
              </ul> 
              <button className="btn btn-md btn-outline-danger mt-3" onClick={() => navigate("/services")} >
                 View Solutions
              </button>
             
            </div>
            {/* IMAGE */}
            <div className="col-lg-6 service-development" data-aos="fade-right">
                <div className="row mt-2 gap-md-2">
                  {/* Our Approach Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-5 col-sm-6 mb-3">
                    <img src="./assets/images/services/our-approach.png" alt="Our Approach" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Our Approach</h5>
                      <p className="mt-1 text-gray-600">
                        We believe in a client-first strategy, ensuring each project is aligned with business goals while delivering top-notch quality and efficiency.
                      </p>
                    </div>
                  </div>

                  {/* Development Strategy Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-6 col-sm-6 mb-3">
                    <img src="./assets/images/services/development-strategy.png" alt="Development Strategy" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Development Strategy</h5>
                      <p className="mt-1 text-gray-600">
                        Our agile methodology ensures flexibility, continuous improvements, and seamless collaboration throughout the development process.
                      </p>
                    </div>
                  </div>

                  {/* Client Feedback Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-6 col-sm-6 mb-3">
                    <img src="./assets/images/services/client-feedback.png" className="img-fluid" alt="Client Feedback" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Client Feedback</h5>
                      <p className="mt-1 text-gray-600">
                        We value our clients' opinions and continuously refine our services based on their feedback, ensuring the best possible outcomes.
                      </p>
                    </div>
                  </div>

                  {/* Our Workflow Card */}
                  <div className="bg-white rounded-xl shadow overflow-hidden col-12 col-md-5 col-sm-6 mb-3">
                    <img src="./assets/images/services/our-workflow.png" alt="Our Workflow" className="img-fluid" />
                    <div className="p-6">
                      <h5 className="text-xl font-semibold text-gray-800">Our Workflow</h5>
                      <p className="mt-1 text-gray-600">
                        A structured workflow allows us to maintain clarity, efficiency, and consistency, ensuring that every project runs smoothly from start to finish.
                      </p>
                    </div>
                  </div>

                
                </div>
              </div>

          </div>
          


        </div>
      </section>
    </>
  );
};

export default About;
